/* eslint-disable no-console */
export const trace =
  // process.env.DEV
  // ?
  (...args: any) => console.log("[src/index]", ...args);
// : () => {};
